<template>
  <div :class="prefixCls">
    <img src="../../../assets/image/logo1.png" />
    <div class="diving-line" />
    <span class="label">Since 1989</span>
  </div>
</template>

<script>
export default {
  name: 'WebsiteLogo',
  data() {
    return {
      prefixCls: this.$prefix + '-layout-header-logo',
    }
  },
  created() {},
}
</script>

<style lang="scss" scoped>
$prefixCls: $namespace + -layout-header-logo;
.#{$prefixCls} {
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    height: 35px;
  }
  .diving-line {
    width: 1px;
    height: 20px;
    background-color: rgb(191, 191, 191);
    margin: 0 10px;
  }
  .label {
    font-size: 18px;
    color: rgb(191, 191, 191);
  }
}
</style>
